import "./styles/quasar.sass";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/mdi-v6/mdi-v6.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {},
};
